import { render, staticRenderFns } from "./PartyFreeDesktop.vue?vue&type=template&id=4efcc828"
import script from "./PartyFreeDesktop.vue?vue&type=script&lang=js"
export * from "./PartyFreeDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports